webpackJsonp([154337994155633],{

/***/ 1604:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"CensusUpdateTarget","kind":"INTERFACE","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":[{"kind":"OBJECT","name":"CensusAssignment","ofType":null},{"kind":"OBJECT","name":"CensusKennel","ofType":null},{"kind":"OBJECT","name":"CensusWard","ofType":null}]}}

/***/ })

});


// WEBPACK FOOTER //
// path---interface-census-update-target-394e5826aa50b159c75e.js